var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSedes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1814_65586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0075 35.8862L8.30152 26.1802C6.38189 24.2605 5.07461 21.8147 4.54499 19.1521C4.01537 16.4895 4.28721 13.7296 5.32612 11.2215C6.36503 8.71332 8.12436 6.56958 10.3816 5.06133C12.6389 3.55307 15.2927 2.74805 18.0075 2.74805C20.7223 2.74805 23.3761 3.55307 25.6334 5.06133C27.8907 6.56958 29.65 8.71332 30.6889 11.2215C31.7278 13.7296 31.9997 16.4895 31.47 19.1521C30.9404 21.8147 29.6331 24.2605 27.7135 26.1802L18.0075 35.8862ZM25.557 24.0236C27.0499 22.5305 28.0666 20.6282 28.4784 18.5573C28.8903 16.4864 28.6788 14.3399 27.8707 12.3892C27.0627 10.4385 25.6943 8.77117 23.9387 7.59813C22.183 6.42509 20.119 5.79898 18.0075 5.79898C15.8961 5.79898 13.832 6.42509 12.0764 7.59813C10.3207 8.77117 8.95237 10.4385 8.1443 12.3892C7.33623 14.3399 7.12475 16.4864 7.53659 18.5573C7.94844 20.6282 8.96512 22.5305 10.4581 24.0236L18.0075 31.5731L25.557 24.0236ZM18.0075 19.5245C17.1985 19.5245 16.4227 19.2031 15.8506 18.6311C15.2786 18.059 14.9572 17.2832 14.9572 16.4742C14.9572 15.6652 15.2786 14.8894 15.8506 14.3173C16.4227 13.7453 17.1985 13.4239 18.0075 13.4239C18.8165 13.4239 19.5923 13.7453 20.1644 14.3173C20.7364 14.8894 21.0578 15.6652 21.0578 16.4742C21.0578 17.2832 20.7364 18.059 20.1644 18.6311C19.5923 19.2031 18.8165 19.5245 18.0075 19.5245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1814_65586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSedes);
export default __webpack_public_path__ + "static/media/logoSedes.ad6d52faac21f6b2e78dbd13b073e080.svg";
export { ForwardRef as ReactComponent };